import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'

import urls from '../urls.json'

async function installDomainName(domain, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(domain)
  const parsedResponse = parseResponse(response)
  const onDoneEvent =
    parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(domain) {
  const url = urls.installDomainName

  const requestData = {
    domain: domain,
    proxyPass: 'https://www.ekidiscount.com',
  }

  const response = await Network.sendPostRequest(url, requestData)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response.response?.statusCode == 200
  ) {
    return {
      statusCode: 200,
      message: 'Domain configured updated',
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { installDomainName }
